import { LitElement, html, css } from 'lit';
import './social-bar.css'


export class SocialBar extends LitElement {

    static properties = {
        title: { type: String },
        orientation: { type: String },
    }

    static styles = css`
    :root{
        
    }
    .main{
        display: inline-flex;
        background-color: var(--background-color, none);
        min-height: 20px;
        align-items : center;
        justify-content : center;
        align-content : center;
        padding: 10px;
        font-size:var(--fontsize, 10px);
        font-family : var(--font-family, Arial, Helvetica, sans-serif);
    }

    .title{
        margin-right : 10px;
        display:inline-flex;
    }
 
    .links{
        display: flex;
        align-content: center;
    }
    
    ::slotted(*) {
        margin: 5px;
        line-height: 1em;
        
    }

    .main.vertical{
        height: auto;
   }
   
    .main.vertical .links{
        flex-direction:column;
    }
    `

    constructor() {
        super();
        this.orientation = "horizontal"
    }



    render() {
        return html`
        <div class="main ${this.orientation}">
            ${this.title ? html`<div class="title">${this.title}</div>` : null}
            <div class="links">
                <slot></slot>
            </div>
        </div>`
    }
}


customElements.define('social-bar', SocialBar);